// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".max-width[data-v-4e8a7538] {\n  max-width: 208px;\n}\n.disabled-box[data-v-4e8a7538] {\n  margin-bottom: 8px;\n}\n.radio-group-box[data-v-4e8a7538] .el-radio {\n  padding-top: 2px;\n  padding-bottom: 2px;\n}", ""]);
// Exports
module.exports = exports;
